import {
  DEFAULT_TRANSITION_DURATION_SEC,
  type SceneTransition,
  type TransitionKind,
} from './types';

/** Assign-at-click randomization: every cut gets a CONCRETE transition drawn
 *  from the selected subset. Renders stay deterministic — there is no
 *  render-time "random" mode. The rng is injected (Math.random at the call
 *  site) per the no-Math.random-in-lib rule. */
export function assignRandomTransitions(
  { cutCount, kinds, rng, durationSec = DEFAULT_TRANSITION_DURATION_SEC }:
  { cutCount: number; kinds: TransitionKind[]; rng: () => number; durationSec?: number },
): SceneTransition[] {
  if (cutCount <= 0 || kinds.length === 0) return [];
  const out: SceneTransition[] = [];
  for (let i = 0; i < cutCount; i++) {
    const pick = Math.min(kinds.length - 1, Math.floor(rng() * kinds.length));
    out.push({ afterSceneIndex: i, kind: kinds[pick], durationSec });
  }
  return out;
}
